import { Helmet as ReactHelmet } from 'react-helmet-async';
import { Head, HeadProps } from './Head';

export default function Helmet(props: HeadProps) {
  return <ReactHelmet>{Head({ ...props })}</ReactHelmet>;
}
